import React, { createContext } from 'react';
import { OrgChartHrMapping } from 'routes/HumanResourcesModule/Settings/OrgChartHrMappings/helpers/type';

export const OrgChartHrMappingsContext: React.Context<OrgChartHrMapping[]> =
    createContext<OrgChartHrMapping[]>([]);

export const useOrgChartHrMappingsContext = () =>
    React.useContext(OrgChartHrMappingsContext);
